import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './navbar.css';
import logo from "../../image/logo11.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const dropdownRef = useRef(null);

  const toggleDropdown = () => setDropdownOpen(prev => !prev);
  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
    setDropdownOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // scroll to top
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  // Helper function to handle navigation, close menus, and scroll to top
  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img 
          src={logo} 
          alt="Logo" 
          className="logo" 
          onClick={handleLogoClick}
        />
      </div>

      <div className="navbar-right">
        {!menuOpen && (
          <button className="hamburger" onClick={toggleMenu}>
            &#9776;
          </button>
        )}

        <ul className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          <li>
            <Link to="/" onClick={() => handleLinkClick('/')}>Home</Link>
          </li>

          <li className="dropdown" ref={dropdownRef}>
            <Link onClick={toggleDropdown} className="dropdown-btn">
              Our Products&nbsp;&nbsp;
            </Link>
            {dropdownOpen && (
              <ul className="dropdown-menu">
                <li><Link to="/pressure-former-machine" onClick={() => handleLinkClick('/pressure-former-machine')}>Pressure Former</Link></li>
                <li><Link to="/cylinder-mould-paper-machine-manufacturers-in-india" onClick={() => handleLinkClick('/cylinder-mould-paper-machine-manufacturers-in-india')}>Cylinder Mould</Link></li>
                <li><Link to="/spiderless-cylinder-mould-manufacturers-in-india" onClick={() => handleLinkClick('/spiderless-cylinder-mould-manufacturers-in-india')}>Spiderless Cylinder Mould</Link></li>
                <li><Link to="/1524mm-pressure-former-cylinder-gasket-manufacturers-in-india" onClick={() => handleLinkClick('/1524mm-pressure-former-cylinder-gasket-manufacturers-in-india')}>1524 Pressure Former</Link></li>
                <li><Link to="/extractor-press-for-paper-mill-machine-manufacturers-in-gujarat-india" onClick={() => handleLinkClick('/extractor-press-for-paper-mill-machine-manufacturers-in-gujarat-india')}>Extractor Press</Link></li>
                <li><Link to="/blade-bar-coater-coating-machine-unit-india" onClick={() => handleLinkClick('/blade-bar-coater-coating-machine-unit-india')}>Blade/Bar Coater</Link></li>
                <li><Link to="/bar-coater-v2-v3-bar-coating-machine-units-in-india" onClick={() => handleLinkClick('/bar-coater-v2-v3-bar-coating-machine-units-in-india')}>Bar Coater V3 & V2</Link></li>
                <li><Link to="/size-press-paper-machine" onClick={() => handleLinkClick('/size-press-paper-machine')}>Size Press</Link></li>
                <li><Link to="/coating-disperser-and-kitchen-equipment-manufacturers-suppliers-in-india" onClick={() => handleLinkClick('/coating-disperser-and-kitchen-equipment-manufacturers-suppliers-in-india')}>Coating Disperser & Kitchen Equipment</Link></li>
                <li><Link to="/roll-cleaner-cleaning-machine" onClick={() => handleLinkClick('/roll-cleaner-cleaning-machine')}>Roll Cleaner</Link></li>
              </ul>
            )}
          </li>

          <li>
            <Link to="/paper-machine-spare-parts-manufacturers-in-gujarat-india" onClick={() => handleLinkClick('/paper-machine-spare-parts-manufacturers-in-gujarat-india')}>
              Spares and Services&nbsp;&nbsp;&nbsp;
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
